<template>
  <div>
    <h1 class="page-header">{{ $t('pickupCardActivator.cardActivator') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @success_create="
              fetchData({ branch_id: branch_id, status_id: status_id })
              " :edit="edit_data" :leave="route_leave" @success_update="edit_data = ''" @cancel="
                fetchData({ branch_id: branch_id, status_id: status_id })
                "></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"></div>
              <div class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end">
                <select class="form-control" v-model.number="status_id" style="width: 120px">
                  <option value disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option v-for="(status, index) in cardStatus" :key="index" :value="status.card_status_id">
                    {{ status.card_status }}
                  </option>
                </select>
                <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" class="ml-2" />
                <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table :columns="columns" :records="resources" :loading="loading">
              <template v-slot="{ record }">
                <td>{{ record.branch.branch_name_en }}</td>
                <td class="with-img" width="2%">
                  <img class="height-30 ts-rounded" v-lazy="{
                    src: guardianPhoto(record),
                    error: onError(record),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }" />
                </td>
                <td class="text-center">
                  {{ record.pickup_card.card_number }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.pickup_card.guardian }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.pickup_card.guardian_kh }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.serial_card }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.registered_date }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <span class="label label-success" v-if="record.status_id == 1">Active</span>
                  <span class="label label-default" v-if="record.status_id == 2">Inactive</span>
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.reason }}</td>
                <td class="ts-whitespace-no-wrap text-center">
                  <a href="#" v-tooltip="$t('tooltip.changeStatus')" class="text-primary"
                    @click.prevent="change(record)">
                    <i class="fas fa-random"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            <ts-total-list v-model="pagination" />
            <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
          </div>
        </ts-card>
        <!-- drawer -->
        <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
          @close="() => (visible = false)" :zIndex="1020" width="300px">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <ts-branch-filter @filter="(value) => (branch_id = value)" />

              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import FormChange from './change.vue'

export default {
  components: {
    FormCreate
  },
  name: 'student-card-activator',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      branch_id: [],
      status_id: 1,
      visible: false,
      route_leave: false,
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      defaultPhoto: require('../../assets/user_default.png'),
      columns: [
        {
          name: this.$t('pickupCardActivator.branch'),
          sortKey: 'branch.branch_name_en'
        },
        {
          name: this.$t('pickupCardActivator.photo')
        },
        {
          name: this.$t('pickupCardActivator.cardNumber'),
          style: 'text-aling: center',
          sortKey: 'pickup_card.card_number'
        },
        {
          name: this.$t('pickupCardActivator.nameEn'),
          sortKey: 'pickup_card.guardian'
        },
        {
          name: this.$t('pickupCardActivator.nameKh'),
          sortKey: 'pickup_card.guardian_kh'
        },
        {
          name: this.$t('pickupCardActivator.serialCard'),
          style: 'text-align:center;',
          sortKey: 'serial_card'
        },
        {
          name: this.$t('pickupCardActivator.registerDate'),
          sortKey: 'registered_date',
          style: 'text-align:center;'
        },
        {
          name: this.$t('pickupCardActivator.status'),
          sortKey: 'status_id',
          style: 'text-align:center;'
        },
        {
          name: this.$t('pickupCardActivator.reason')
        },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('pickupCardActivator', [
      'resources',
      'pagination',
      'cardStatus'
    ]),
    search: {
      get() {
        return this.$store.state.pickupCardActivator.search
      },
      set(newVal) {
        this.$store.commit('pickupCardActivator/SET_SEARCH', newVal)
        this.$store.commit('pickupCardActivator/RESET_CURRENT_PAGE')
      }
    },
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('pickupCardActivator/dataBeforeCreate')
        .then(() => {
          this.fetchData({ status_id: this.status_id })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes = {}) {
      this.loading = true

      this.$store
        .dispatch(
          'pickupCardActivator/fetch',
          Object.assign(
            {
              branch_id: this.branch_id,
              status_id: this.status_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    change(data) {
      this.$modal.show(
        FormChange,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    guardianPhoto(record) {
      if (record.pickup_card.photo) {
        return record.pickup_card.photo
      }
      if (record.pickup_card.relationship == 'Father') {
        return this.manPhoto
      }
      if (record.pickup_card.relationship == 'Mother') {
        return this.womenPhoto
      }
      if (record.pickup_card.relationship == 'Other') {
        return this.defaultPhoto
      }
    },

    onError(record) {
      event
        ? (event.target.src =
          record.pickup_card.relationship == 'Father'
            ? this.manPhoto
            : this.womenPhoto)
        : ''
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        status_id: this.status_id,
        branch_id: this.branch_id
      })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value, status_id: this.status_id })
    }, 500),
    status_id: debounce(function (value) {
      this.fetchData({ status_id: value, branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'pickup-card-activator-create') {
      this.$store.commit('pickupCardActivator/RESET_STATE')
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
